import {
  DoorStickerTemplate,
  FlyerTemplate,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';

export default {
  title: 'Produse tipărite',
  types: {
    [PolygraphyProductType.Flyer]: {
      name: 'Flyere',
      templates: {
        [FlyerTemplate.One]: '#1 🆕',
        [FlyerTemplate.Two]: '#2  🆕',
        [FlyerTemplate.Three]: '#3',
        [FlyerTemplate.Four]: '#4',
      },
    },
    [PolygraphyProductType.Sticker]: {
      name: 'Autocolante',
      templates: {
        [StickerTemplate.One]: '#1 🆕',
      },
    },
    [PolygraphyProductType.DoorSticker]: {
      name: 'Autocolante pentru uși',
      templates: {
        [DoorStickerTemplate.One]: '#1 🆕',
        [DoorStickerTemplate.Two]: '#2 🆕',
      },
    },
    [PolygraphyProductType.Custom]: {
      name: 'Produse tipărite personalizate',
    },
  },
  buttons: {
    order: 'Comandă nouă',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea datelor',
  },
};
